import PeriprocedureelBeleidApixaban from "../../../../src/client/lta-antistolling/periprocedureel-beleid-apixaban.json";
import * as React from 'react';
export default {
  PeriprocedureelBeleidApixaban,
  React
};